import { useQuery } from 'react-query'
import { getPaymentsRetention } from './paymentsRetentionApi'

export const usePaymentsRetention = () => {
  return useQuery({
    queryKey: ['invoicingPaymentsRetention'],
    queryFn: getPaymentsRetention,
  })
}
